module.exports = __webpack_public_path__ + "img/9788958203292.721972da.jpg";